import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as dataActions from "../../../utils/data/dataActions";
class AutoSave extends React.Component {
  /**
   * Component that will allow us to make api calls on field value changes.
   * The component can be implemented in field components, while passing the right props that will
   * render this component. The props passed to this component must be changed by the onChange function of the
   * field where we want to auto save.
   */
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.callAPI = this.callAPI.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.timer = null;
    this.update();
  }

  callAPI(objToSend = {}) {
    const model = {
      path: this.props.apiEndpoint,
    };
    this.props.dataActions
      .simplePost({ model, data: objToSend })
      .then((res) => {
        this.props.setAPIResponse(res);
      });
  }

  handleUpdate() {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.callAPI(this.props.body);
    }, 500); // setTimeout allows us to prevent api call spamming. Delay: 500ms between each call.
  }

  update() {
    this.handleUpdate();
  }

  render() {
    return <i className="hidden" />;
  }
}

AutoSave.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  setAPIResponse: PropTypes.func.isRequired,
  dataActions: PropTypes.object,
  body: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(AutoSave);



// WEBPACK FOOTER //
// ./src/components/common/AutoSave/AutoSave.js